import { IYearDTO } from '@/dtos';
import { get } from '@/services/apiWrapper';
export const getCurrentYearAPI = async (): Promise<IYearDTO> => {
  const year = await get<IYearDTO>(`/getCurrentYear`);
  return year;
};

export const getYearAnonAPI = async (yearId: string): Promise<IYearDTO> => {
  const year = await get<IYearDTO>(`/year/anon/${yearId}`);
  return year;
};
